import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useIsDesktop, useIsTablet } from "@/hooks";
import { useGalleryContext } from "@/gallery/contexts";
import { useImages } from "@/gallery/hooks";
import { useFloorplans } from "../Sections/Floorplan";
import { PrintPreview } from "./components/Preview/PrintPreview";
import { DesktopPreview } from "./components/Preview/DesktopPreview";
import { MobilePreview } from "./components/Preview/MobilePreview";
import { MasonryModal } from "./components/Masonry";
import { SliderModal } from "./components/SliderModal";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
export const galleryTestId = "cdp-gallery";
export const Gallery = () => {
    // On SSR both previews (mobile AND desktop) are mounted in the DOM
    // On CSR only the relevant preview (mobile OR preview) is mounted in the DOM
    const isTablet = useIsTablet();
    const isDesktop = useIsDesktop();
    const { isSliderModalOpen, openSliderModal, isMasonryModalOpen, openMasonryModal, updateTab, } = useGalleryContext();
    const { imagesCount } = useImages();
    const { floorplansCount } = useFloorplans();
    const handleOpen = () => {
        if (imagesCount === 0 && floorplansCount > 3) {
            openMasonryModal();
            updateTab(TAB_ITEMS.FLOORPLANS);
        }
        else if (imagesCount === 0 &&
            floorplansCount > 0 &&
            floorplansCount <= 3) {
            openSliderModal();
            updateTab(TAB_ITEMS.FLOORPLANS);
        }
        else if (imagesCount > 0 && imagesCount <= 3) {
            updateTab(TAB_ITEMS.IMAGES);
            openSliderModal();
        }
        else if (imagesCount > 3) {
            updateTab(TAB_ITEMS.IMAGES);
            openMasonryModal();
        }
    };
    return (_jsx(_Fragment, { children: _jsxs(Box, { as: "section", testId: galleryTestId, marginBottom: {
                "breakpoint.lg": "spacing.24",
            }, position: "relative", unsafe_className: "Gallery", id: "overview", children: [_jsx(PrintPreview, {}), isDesktop && (_jsx(DesktopPreview, { openModal: handleOpen, testId: galleryTestId })), isTablet && (_jsx(MobilePreview, { openModal: handleOpen, testId: galleryTestId })), _jsx(SliderModal, { isOpen: isSliderModalOpen, testId: galleryTestId }), _jsx(MasonryModal, { isOpen: isMasonryModalOpen, testId: `${galleryTestId}.MasonryModal` })] }) }));
};
